import { AppRouteProps } from "@harea/component";
import React from "react";

const DocumentsUserDetailsContainer = React.lazy(() => import('./containers/DocumentsUserDetailsContainer'));

export const DocumentsUserDetailsRoutes: Array<AppRouteProps> = [
    {
        path: 'documents',
        element: <DocumentsUserDetailsContainer />,
    }
];
